<template>
  <div class="kakao-map-wrapper">
    <div ref="mapContainer" class="map-container"></div>
    <div v-if="loading" class="loading">지도 로딩 중...</div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'

export default {
  name: 'KakaoMap',
  props: {
    address: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const mapContainer = ref(null)
    const loading = ref(true)

    onMounted(() => {
      // ✅ window.kakao가 로드될 때까지 기다림
      const initMap = () => {
        if (!window.kakao || !window.kakao.maps) {
          setTimeout(initMap, 100)
          return
        }

        loading.value = false
        
        const geocoder = new window.kakao.maps.services.Geocoder()
        
        geocoder.addressSearch(props.address, (result, status) => {
          if (status === window.kakao.maps.services.Status.OK) {
            const coords = new window.kakao.maps.LatLng(result[0].y, result[0].x)
            
            const map = new window.kakao.maps.Map(mapContainer.value, {
              center: coords,
              level: 3
            })
            
            new window.kakao.maps.Marker({
              map: map,
              position: coords
            })
          }
        })
      }

      initMap()
    })

    return { mapContainer, loading }
  }
}
</script>

<style scoped>
.kakao-map-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
}

.map-container {
  width: 100%;
  height: 100%;
}

.loading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>